// Base service name
export const SERVICE_NAME = "LANGUAGE_SERVICE";
